import { render, staticRenderFns } from "./UserTag.vue?vue&type=template&id=a701bb78&lang=pug"
import script from "./UserTag.vue?vue&type=script&lang=js"
export * from "./UserTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports